import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { Plot, PlotStatusEnum } from '@/api/rest/resources/types/plot';
import { useMembershipType } from '@/hooks/useMembershipType';
import { usePathSet } from '@/hooks/usePathSet';
import { buildPath } from '@/utils/buildPath';

export const useDestinationPath = () => {
  const pathSet = usePathSet();
  const membershipType = useMembershipType();

  const getDestinationPath = (plot: Plot) => {
    const projectId = (plot.project ?? plot.project_id) as string;
    if (membershipType === MembershipWithOrganizationTypeEnum.land_steward) {
      if (plot.status === PlotStatusEnum.invalid) {
        return buildPath(pathSet.editPlot, {
          pathParams: { projectId, plotId: plot.id },
        });
      }
      return buildPath(pathSet.plot, {
        pathParams: { projectId, plotId: plot.id },
      });
    }

    if (plot.status !== PlotStatusEnum.invalid) {
      return buildPath(pathSet.plot, {
        pathParams: { projectId, plotId: plot.id },
      });
    }
    return null;
  };

  return { getDestinationPath };
};
